import { useEffect } from 'react';

import { useShowCause } from 'core/Api';
import { useBreakPoints, usePlatformService } from 'core/Hooks';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import { LoadingOverlay } from 'ui';

import { ReferralLayout } from './ReferralLayout';

export const Cause = () => {
  const navigate = useNavigate();

  const Platform = usePlatformService();
  const { isDesktop, isMobile } = useBreakPoints();
  const { uuid } = useParams<{ uuid: string }>();
  const { data: cause, isLoading, isError } = useShowCause(uuid);

  useEffect(() => {
    if (isError) {
      navigate('/sign-up');
    }
  }, [isError]);

  if (isLoading) {
    return <LoadingOverlay visible={true} />;
  }

  if (Platform.isNative) {
    // If native, send the user to the new native Onboarding Route!
    return <Navigate to="/native/get-started" />;
  } else if (isDesktop) {
    return <ReferralLayout.Desktop />;
  } else if (isMobile) {
    return <ReferralLayout.Mobile cause={cause} />;
  }

  return <ReferralLayout.Mobile cause={cause} />;
};
